module.exports = __webpack_public_path__ + "img/CARA_BLADE.aa769513.jpg";